/**
 * Register the service worker, which is what makes Chrome offer "Install app".
 *
 * Production only. In development Vite serves modules unbundled and reloads them
 * over a websocket; a worker sitting in front of that intercepts requests the
 * dev server expects to answer itself, and the usual symptom is an edit that
 * does not appear no matter how often you save.
 *
 * Nothing here is allowed to affect the page. A browser with no service worker
 * support, a refused registration, a private window with storage disabled — all
 * of them mean "no install button", never "no app".
 */
export function registerServiceWorker() {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // After load, so registering never competes with the first render for
  // bandwidth on the slow phone this is mostly used on.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Deliberately silent. The dashboards work; only installability is lost,
      // and a console error here would be caught by the browser-diagnostics
      // assertion in the e2e tour and reported as a broken screen.
    });
  });
}

export default registerServiceWorker;
